/*!
 * el-table-infinite-scroll v2.0.3
 * (c) 2019-2025 yujinpan
 */

import ElTableInfiniteScroll from './el-table-infinite-scroll.js';
export { default } from './el-table-infinite-scroll.js';

// @ts-ignore
ElTableInfiniteScroll.install = function (Vue) {
  Vue.directive('el-table-infinite-scroll', ElTableInfiniteScroll);
};
